module.exports = __webpack_public_path__ + "img/product_advantages_1.677fef5d.png";